<template>
  <div>
    <bs-card class="card-info" :icon="['fal', 'user-friends']" :label="$t('labels.' + camelToSnake($options.name))">
      <template v-slot:header>
        <bs-button v-if="auth.can['edit_customer_contacts']" class="btn-sm btn-info" @click="create">{{ $t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.create') }) }}</bs-button>
      </template>
      <bs-table v-bind="{dataLength, loading}" :cols="6">
        <template v-slot:thead>
          <tr>
            <th style="width:40px"></th>
            <bs-th :label="$t('labels.name')" :sortable="resourceState.sort" :col="'first_name'" @click="applySort"></bs-th>
            <bs-th :label="$t('labels.phone')" :sortable="resourceState.sort" :col="'phone'" @click="applySort"></bs-th>
            <bs-th :label="$t('labels.email')" :sortable="resourceState.sort" :col="'email'" @click="applySort"></bs-th>
            <bs-th :label="$t('labels.manages_property')"></bs-th>
            <th></th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td><avatar :user="r" /></td>
          <td>
            <b v-if="r.primary">{{ r.name }}</b>
            <span v-else>{{ r.name }}</span>
          </td>
          <td>
            <a :href="`tel:${r.phone1}`">{{ r.phone1 }}</a>
          </td>
          <td>{{ r.email }}</td>
          <td>{{ joinObjects(', ', 'label', r.properties) }}</td>
          <td class="t3">
            <bs-action v-if="auth.can['edit_customer_contacts']" :icon="['fal', 'pencil']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.edit') })" class="btn-info" @click="update(r)"></bs-action>
            <bs-action v-if="auth.can['edit_customer_contacts']" :icon="['fal', 'trash']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })" class="btn-danger" @click="destroy(r)"></bs-action>
          </td>
        </tr>
        <template v-slot:tfoot>
          <pagination :data="resources" :state="resourceState" @pushPage="index" :counts="[5,10]"></pagination>
        </template>
      </bs-table>
    </bs-card>
    <bs-modal :name="'create-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: resource.id ? $t('labels.edit') : $t('labels.create') })">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="slotProps">
          <file-field :name="'picture'" :label="$t('labels.profile_picture')" v-model="resource.picture" :error="slotProps.error"></file-field>
          <tuxedo-input :name="'name'" :label="$t('labels.name')" v-model="resource.name" :error="slotProps.error" />
          <tuxedo-input :type="'email'" :name="'email'" :label="$t('labels.email')" v-model="resource.email" :error="slotProps.error" />
          <div class="row">
            <div class="col-6">
              <tuxedo-input :name="'phone1'" :label="$t('labels.phone')" v-model="resource.phone1" :error="slotProps.error" />
            </div>
            <div class="col-6">
              <tuxedo-input :name="'phone2'" :label="$t('labels.phone')" v-model="resource.phone2" :error="slotProps.error" />
            </div>
          </div>
          <div class="form-group bs-form-group">
            <label class="text-uppercase mb-0">{{ $t('labels.manages_property') }}</label>
            <multiselect v-model="resource.properties" :options="properties" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="false" :placeholder="$t('labels.choose_options', { resources: $tc('labels.property', 0) })" label="label" track-by="id">
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="values.length & !isOpen">{{ $t('labels.chosen_options', { count: values.length, resources: $tc('labels.property', values.length) }) }}</span>
              </template>
            </multiselect>
          </div>
          <toggle-field :name="'primary'" :label="$t('labels.primary')" v-model="resource.primary" />
        </template>
      </bs-form>
    </bs-modal>
    <bs-modal :name="'destroy-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })">
      <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
        {{ $t('messages.delete', { resource: $t('labels.contact') }) }}
      </bs-form>
    </bs-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapState, mapMutations } from 'vuex'
import helpers from '../../helpers'

export default {
  name: 'Contacts',
  props: ['customer'],
  components: {
    Multiselect
  },
  data () {
    return {
      loading: false,
      dataLoading: false,
      activeId: null,
      assignedClients: [],
      resource: {
        picture: null,
        name: '',
        primary: false,
        phone1: '',
        phone2: '',
        email: '',
        properties: []
      }
    }
  },
  mounted () {
    this.index(this.page)
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      resourceState: state => state.contactsState,
      resources: state => state.contacts,
      submitting: state => state.submitting,
      properties: state => state.propertiesStore
    }),
    dataLength () {
      let length = 0
      if (this.resources.data) length = this.resources.data.length
      return Math.max(this.resourceState.tableRows - length, 0)
    }
  },
  methods: {
    ...mapMutations([
      'pushState'
    ]),
    joinObjects: helpers.joinObjects,
    applySort (val) {
      this.pushState({ view: this.$options.name, key: 'sort', data: val })
      this.index()
    },
    index (page, count) {
      if (page) this.pushState({ view: this.$options.name, key: 'page', data: page })
      if (count) this.pushState({ view: this.$options.name, key: 'tableRows', data: count })
      this.loading = true
      this.$store.dispatch('index', { collection: this.$options.name, path: 'customers', id: this.customer, tag: 'contacts' }).then(() => {
        this.loading = false
      })
    },
    create () {
      this.$store.commit('axiosError', null)
      this.$root.clearData(this.resource)
      this.$modal.show('create-' + this.$options.name)
    },
    destroy (o) {
      this.activeId = o.id
      this.$modal.show('destroy-' + this.$options.name)
    },
    update (o) {
      this.$store.commit('axiosError', null)
      this.resource = JSON.parse(JSON.stringify(o))
      this.$modal.show('create-' + this.$options.name)
    },
    submit () {
      this.$store.dispatch('chunk', {
        url: '/api/customers/' + this.customer + '/contacts',
        resource: this.resource,
        icon: ['fal', 'user'],
        message: this.$t('messages.uploading_image'),
        collection: this.$options.name,
        callback: () => { this.index() }
      }).then(() => {
        this.$modal.hide('create-Contacts')
      })
    },
    destruction () {
      this.$store.dispatch('destroy', { collection: this.$options.name, id: this.activeId }).then(() => {
        this.$modal.hide('destroy-' + this.$options.name)
      })
    }
  }
}
</script>
